import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {Keys, StorageService} from './storage.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {FinalCertificate} from '../interest-certificate/final-certificate';

@Injectable()
export class InterestCertificateService {
    private readonly baseUrl: string;
    private readonly httpClient: HttpClient;
    private readonly storageService: StorageService;

    constructor(httpClient: HttpClient, configService: ConfigService, storageService: StorageService) {
        this.httpClient = httpClient;
        this.storageService = storageService;
        this.baseUrl = configService.baseUrl();
    }

    public async getFinalCertificates(): Promise<FinalCertificate[]> {
        const interestCertificateUrl = `${this.baseUrl}interest-certificates`;
        const httpParams = new HttpParams().set('certificateType', 'final')
            .set('lenderId', this.storageService.getItem(Keys.LENDER_ID));

        return await this.httpClient.get<FinalCertificate[]>(interestCertificateUrl, {params: httpParams}).toPromise();
    }

    public async getFlexFinalCertificates(): Promise<FinalCertificate[]> {
        const interestCertificateUrl = `${this.baseUrl}interest-certificates`;
        const httpParams = new HttpParams().set('certificateType', 'flex_final')
            .set('lenderId', this.storageService.getItem(Keys.LENDER_ID));

        return await this.httpClient.get<FinalCertificate[]>(interestCertificateUrl, {params: httpParams}).toPromise();
    }
    
}